import { isFuture } from 'date-fns';

/**
 * Check if a date is in the future
 *
 * Returns true if the date is after the current moment.
 *
 * @param date - Date to check (Date object or ISO string)
 *
 * @returns true if the date is in the future
 *
 * @example
 * ```ts
 * // Current time: 2025-01-15 14:00
 *
 * // Tomorrow
 * isFutureDate('2025-01-16T12:00:00.000Z')
 * // => true
 *
 * // Today at 16:00 (future time today)
 * isFutureDate('2025-01-15T16:00:00.000Z')
 * // => true
 *
 * // Today at 12:00 (past time today)
 * isFutureDate('2025-01-15T12:00:00.000Z')
 * // => false
 *
 * // Yesterday
 * isFutureDate('2025-01-14T12:00:00.000Z')
 * // => false
 * ```
 */
export const isFutureDate = (date: Date | string): boolean => {
  const targetDate = typeof date === 'string' ? new Date(date) : date;

  return isFuture(targetDate);
};
